import SendSummaryEmailPopup from './SendSummaryEmailPopup'

export default SendSummaryEmailPopup
